var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypagePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/General/Wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0096 10.1713L21.0122 13.7942C20.9867 14.1393 20.9538 14.484 20.9136 14.8281C20.8463 15.4035 20.3785 15.8677 19.7911 15.9333C17.9514 16.139 16.0476 16.139 14.2078 15.9333C13.6204 15.8677 13.1527 15.4035 13.0854 14.8281C12.8656 12.9491 12.8656 11.0509 13.0854 9.17189C13.1527 8.59648 13.6204 8.13234 14.2078 8.06669C16.0476 7.86107 17.9514 7.86107 19.7911 8.06669C20.3785 8.13234 20.8463 8.59648 20.9136 9.17189C20.9525 9.5045 20.9845 9.8377 21.0096 10.1713ZM16.9995 10.5C16.171 10.5 15.4995 11.1716 15.4995 12C15.4995 12.8284 16.171 13.5 16.9995 13.5C17.8279 13.5 18.4995 12.8284 18.4995 12C18.4995 11.1716 17.8279 10.5 16.9995 10.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4031 6.03973C20.5586 6.30899 20.2667 6.61051 19.9577 6.57597C18.0073 6.35798 15.9917 6.35798 14.0412 6.57597C12.7718 6.71784 11.7453 7.71738 11.5955 8.99764C11.3622 10.9924 11.3622 13.0076 11.5955 15.0024C11.7453 16.2826 12.7718 17.2822 14.0412 17.4241C15.9917 17.642 18.0073 17.642 19.9577 17.4241C20.2688 17.3893 20.563 17.6929 20.406 17.9637C19.6274 19.3065 18.2393 20.2437 16.6263 20.4134L15.9744 20.482C12.6636 20.8304 9.32413 20.8074 6.01838 20.4135L5.58644 20.362C3.80431 20.1497 2.39226 18.7573 2.15489 16.9784C1.714 13.6741 1.714 10.3259 2.15489 7.02166C2.39226 5.2427 3.80431 3.85034 5.58643 3.63798L6.01837 3.58651C9.32413 3.19258 12.6636 3.16961 15.9744 3.51801L16.6263 3.58661C18.2407 3.75649 19.6266 4.6951 20.4031 6.03973Z",
    fill: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypagePay);
export default __webpack_public_path__ + "static/media/mypage_pay.4d8ae34d2ecc8a6bcd961fe43c6aef30.svg";
export { ForwardRef as ReactComponent };